export const socials = [
  { name: 'ВКонтакте', mod: 'vk', link: 'https://vk.com/chocolate_museum_vbg' },
  { name: 'VK Видео', mod: 'vk-video', link: 'https://vk.com/video/@chocolate_museum_vbg' },
  { name: 'YouTube', mod: 'yt', link: 'https://www.youtube.com/channel/UCg93Lds1jruY7fszu-GLl3w' },
  { name: 'Telegram', mod: 'tg', link: 'https://t.me/chocomuseum_vbg' },
  { name: 'Instagram', mod: 'in', link: 'https://instagram.com/chocolate_museum_vbg?igshid=9rm8elqv2gk1' }
]

export const whatsAppLink = { name: 'WhatsApp', mod: 'wt', link: 'https://wa.me/79818479923' }
